import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Collapse } from 'reactstrap';
import DownIcon from 'mdi-react/ChevronDownIcon';
import PropTypes from 'prop-types';
import {environment} from '../../../containers/environment';

const br = `${process.env.PUBLIC_URL}/img/language/br.png`;
const gb = `${process.env.PUBLIC_URL}/img/language/gb.png`;

const BrLng = () => (
    <span className="topbar__language-btn-title">
    <img src={br} alt="br" />
    <span>Português</span>
  </span>
);

const GbLng = () => (
    <span className="topbar__language-btn-title">
    <img src={gb} alt="gb" />
    <span>English</span>
  </span>
);

class TopbarLanguage extends PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({ changeLanguage: PropTypes.func }).isRequired,
  };

  constructor(props) {
    super();

    let lng = localStorage.getItem(environment.LANGUAGE);
    let option = <BrLng />;
    if(lng !== null && lng !== undefined){
      props.i18n.changeLanguage(lng);
      option = this.getLanguage(lng);
    }else{
      localStorage.setItem(environment.LANGUAGE, 'br');
    }

    this.state = {
      collapse: false,
      mainButtonContent: option,
    };
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  getLanguage = (lng) => {
    switch (lng) {
      case 'br':
        return <BrLng />;
      case 'en':
        return <GbLng />;
      default:
        return <BrLng />;
    }
  };

  changeLanguage = (lng) => {
    // const { i18n } = this.props;
    // i18n.changeLanguage(lng);
    // switch (lng) {
    //   case 'br':
    //     this.setState({ mainButtonContent: <BrLng /> });
    //     break;
    //   case 'en':
    //     this.setState({ mainButtonContent: <GbLng /> });
    //     break;
    //   default:
    //     this.setState({ mainButtonContent: <BrLng /> });
    //     break;
    // }
    localStorage.setItem(environment.LANGUAGE, lng);
    window.location.reload();
  };

  render() {
    const { mainButtonContent, collapse } = this.state;

    return (
      <div className="topbar__collapse topbar__collapse--language">
        <button className="topbar__btn" type="button" onClick={this.toggle}>
          {mainButtonContent}
          <DownIcon className="topbar__icon" />
        </button>
        {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}
        <Collapse
          isOpen={collapse}
          className="topbar__collapse-content topbar__collapse-content--language"
        >
          <button
              className="topbar__language-btn"
              type="button"
              onClick={() => this.changeLanguage('br')}
          >
            <BrLng />
          </button>
          <button
              className="topbar__language-btn"
              type="button"
              onClick={() => this.changeLanguage('en')}
          >
            <GbLng />
          </button>
        </Collapse>
      </div>
    );
  }
}

export default withTranslation('common')(TopbarLanguage);
